import { useEffect, useState } from 'react'
import { Link, useOutletContext, useParams } from 'react-router-dom'

import { listGroupConfigs } from '../../../api/groupConfigs.js'

function formatDate(value) {
  if (!value) return ''
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return String(value)
  return parsed.toLocaleString()
}

export default function ApplicationGroupConfigsListPage() {
  const outlet = useOutletContext()
  const { id: applicationIdFromParams } = useParams()
  const applicationId = outlet?.applicationId || applicationIdFromParams
  const [state, setState] = useState({
    status: 'loading',
    data: [],
    error: null,
  })

  useEffect(() => {
    let cancelled = false

    setState({
      status: 'loading',
      data: [],
      error: null,
    })

    listGroupConfigs(applicationId)
      .then((data) => {
        if (!cancelled) {
          const sorted = [...data].sort((a, b) => String(a.name).localeCompare(String(b.name)))
          setState({
            status: 'ok',
            data: sorted,
            error: null,
          })
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({
            status: 'error',
            data: [],
            error,
          })
        }
      })

    return () => {
      cancelled = true
    }
  }, [applicationId])

  return (
    <section className="card sectionCard">
      <div className="pageHeader pageHeaderTight">
        <div>
          <div className="cardTitle">Group configs</div>
        </div>
        <div className="buttonGroup">
          <Link to={`/applications/${applicationId}/configs/new`} className="button buttonPrimary">
            Create
          </Link>
        </div>
      </div>

        {state.status === 'loading' ? (
          <p className="muted inlineMessage">
            Loading group configs...
          </p>
        ) : null}

        {state.status === 'error' ? (
          <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
        ) : null}

        {state.status === 'ok' && state.data.length === 0 ? (
          <p className="muted inlineMessage">
            No group configs yet. Create one to start building segments and elements.
          </p>
        ) : null}

        {state.status === 'ok' && state.data.length > 0 ? (
          <table className="table" aria-label="Group configs list">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Start bundle version</th>
                <th>Created</th>
                <th>Updated</th>
                <th className="alignRight"></th>
              </tr>
            </thead>
            <tbody>
              {state.data.map((gc) => (
                <tr key={gc.id}>
                  <td>{gc.name || 'Untitled'}</td>
                  <td>{gc.description ?? ''}</td>
                  <td>{gc.startBundleVersion || ''}</td>
                  <td>{formatDate(gc.createdAt)}</td>
                  <td>{formatDate(gc.updatedAt)}</td>
                  <td className="alignRight">
                    <span className="tableActions">
                      <Link to={`/applications/${applicationId}/configs/${gc.id}`} className="button buttonGhost">
                        Configs
                      </Link>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
    </section>
  )
}

